import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Flashcard } from "types/external/swayam/flashcard"

interface FlashcardState {
  currentFlashcard: Flashcard | null
  filteredFlashcards: Flashcard[]
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
}

const initialState: FlashcardState = {
  currentFlashcard: null,
  filteredFlashcards: [],
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    video_url: "video_na",
    widget_code: "flashcards",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        topic: "flashcard",
        difficulty_level: "medium",
        time_in_sec: 0,
        question_count: 0,
        consider_history: false,
        custom_instructions: null,
        num_cards: 0,
        cards_viewed: 0,
        time_spent_seconds: 0,
      },
      assessment_obj: {
        topic: "topic_na",
        num_cards: 0,
        cards_viewed: 0,
        time_spent_seconds: 0,
      },
      interaction: {},
      interactions: [],
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: true,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const FlashcardSlice = createSlice({
  name: "flashcard",
  initialState,
  reducers: {
    setCurrentFlashcard: (state, action: PayloadAction<Flashcard | null>) => {
      state.currentFlashcard = action.payload
    },
    setFilteredFlashcards: (state, action: PayloadAction<Flashcard[]>) => {
      state.filteredFlashcards = action.payload
    },
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  resetState,
  setCurrentFlashcard,
  setFilteredFlashcards,
  setAuditLogsCompleteData,
  setAuditLogsHeartbeatStarted,
} = FlashcardSlice.actions
export default FlashcardSlice.reducer
